import styled from 'styled-components'

import { media } from '../../../../../../utils/style-utils'

export const Container = styled.div`
  width: 100%;
  height: 80%;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  padding-right: 5rem;

  ${media.xxl`
    height: auto;
    justify-content: center;
    padding-right: 1.5rem;
  `}
`
